<div [ngStyle]="layoutStyle"><ng-template app-form-record-field-holder></ng-template></div>
